import { StoreState } from '@/store'
import { useSelector } from 'react-redux'

const useToken = () => {
  const { token } = useSelector((state: StoreState) => state.ssr)

  return { token, isLogin: !!token }
}

export default useToken
